const pt = {
  brand: "E2 Care",
  tagline: "Cuidados calmos e conectados.",
  nav_dashboard: "Painel",
  nav_residents: "Pacientes",
  nav_patients: "Pacientes",
  nav_rooms: "Quartos",
  nav_devices: "Dispositivos",
  nav_events: "Eventos",
  nav_alerts: "Alertas",
  nav_users: "Equipa",
  nav_settings: "Definições",
  nav_admin: "Administração",
  nav_signout: "Sair",
  topbar_search_placeholder: "Pesquisar pacientes, quartos, dispositivos…",
  admin_super_only: "Apenas superadministradores podem gerir organizações.",
  admin_admin_only: "Apenas administradores podem aceder a esta página.",
  admin_tab_orgs: "Organizações",
  admin_tab_users: "Utilizadores",
  admin_tab_patients: "Pacientes",
  admin_tab_rooms: "Quartos",
  admin_tab_buildings: "Edifícios",
  admin_tab_devices: "Dispositivos",
  admin_tab_alerts: "Alertas",
  admin_tab_qa: "Ferramentas de teste",
  admin_delete: "Eliminar",
  admin_no_orgs_yet: "Ainda não há organizações.",
  admin_field_name: "Nome",
  admin_field_email: "E-mail",
  admin_field_phone: "Telefone",
  admin_field_password: "Palavra-passe",
  admin_field_role: "Função",
  admin_field_type: "Tipo",
  admin_field_timezone: "Fuso horário",
  admin_field_address: "Morada",
  admin_field_status: "Estado",
  admin_field_organization: "Organização",
  admin_password_keep: "Deixe em branco para manter",
  admin_field_birth_date: "Data de nascimento",
  admin_field_room: "Quarto",
  admin_field_room_none: "Não atribuído",
  admin_field_photo: "URL da foto",
  admin_field_photo_hint: "Cole um URL público — upload completo na v2.",
  admin_field_notes: "Notas do cuidador",
  admin_field_emergency_contact: "Contacto de emergência principal",
  admin_field_ec_name: "Nome",
  admin_field_ec_phone: "Telefone",
  admin_field_ec_relationship: "Relação",
  admin_field_mac: "Endereço MAC",
  admin_field_firmware: "Firmware",
  admin_field_assignment: "Atribuído a",
  admin_field_assigned_room: "Quarto atribuído",
  admin_field_assigned_patient: "Paciente atribuído",
  admin_field_assigned_hint: "Opcional. Sensores → quarto; pulseiras → paciente.",
  admin_field_sensor_target: "Montado em",
  admin_field_sensor_target_hint: "Indica ao sistema se este sensor vigia uma porta ou uma janela.",
  sensor_target_door: "Porta",
  sensor_target_window: "Janela",
  sensor_target_unset: "Não configurado",
  admin_field_sensor_label: "Etiqueta do sensor",
  admin_field_sensor_label_hint: "Nome amigável mostrado em alertas e eventos — p. ex. «Porta da frente», «Janela da casa de banho».",
  admin_field_building: "Edifício",
  admin_field_building_required: "Um quarto deve pertencer a um edifício.",
  room_openings: "Aberturas",
  room_no_openings: "Ainda não há sensores de porta ou janela instalados neste quarto.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Última alteração",
  admin_field_description: "Descrição",
  admin_field_severity: "Gravidade",
  admin_field_patient: "Paciente",
  admin_field_device: "Dispositivo",
  admin_field_message: "Mensagem",
  admin_orgs_title: "Organizações",
  admin_orgs_sub: "Criar, editar e arquivar inquilinos do E2 Care.",
  admin_orgs_count: "organizações",
  admin_org_new: "Nova organização",
  admin_org_new_title: "Nova organização",
  admin_org_edit_title: "Editar organização",
  admin_org_created: "Organização criada.",
  admin_org_updated: "Organização atualizada.",
  admin_org_deleted: "Organização arquivada.",
  admin_org_delete_title: "Arquivar organização?",
  admin_org_delete_confirm: "«{name}» será ocultada das listas.",
  admin_users_title: "Utilizadores",
  admin_users_sub_super: "Gerir todas as contas de utilizador em todos os inquilinos.",
  admin_users_sub_org: "Gerir contas de utilizador de {org}.",
  admin_user_new: "Novo utilizador",
  admin_user_new_title: "Novo utilizador",
  admin_user_edit_title: "Editar utilizador",
  admin_user_created: "Utilizador criado.",
  admin_user_updated: "Utilizador atualizado.",
  admin_user_deleted: "Utilizador arquivado.",
  admin_user_delete_title: "Arquivar utilizador?",
  admin_user_delete_confirm: "«{name}» perderá o acesso.",
  admin_user_memberships: "Pertenças a organizações",
  admin_patients_title: "Pacientes",
  admin_patients_sub_super: "Gerir todos os pacientes em todos os inquilinos.",
  admin_patients_sub_org: "Gerir pacientes em {org}.",
  admin_patient_new: "Novo paciente",
  admin_patient_new_title: "Novo paciente",
  admin_patient_edit_title: "Editar paciente",
  admin_patient_created: "Paciente criado.",
  admin_patient_updated: "Paciente atualizado.",
  admin_patient_deleted: "Paciente arquivado.",
  admin_patient_delete_title: "Arquivar paciente?",
  admin_patient_delete_confirm: "«{name}» será ocultado das listas.",
  admin_rooms_title: "Quartos",
  admin_rooms_sub_super: "Configurar quartos em todos os inquilinos.",
  admin_rooms_sub_org: "Configurar quartos em {org}.",
  admin_room_new: "Novo quarto",
  admin_room_new_title: "Novo quarto",
  admin_room_edit_title: "Editar quarto",
  admin_room_created: "Quarto criado.",
  admin_room_updated: "Quarto atualizado.",
  admin_room_deleted: "Quarto arquivado.",
  admin_room_delete_title: "Arquivar quarto?",
  admin_room_delete_confirm: "«{name}» será ocultado.",
  admin_devices_title: "Dispositivos",
  admin_devices_sub_super: "Aprovisionar dispositivos Moko em todos os inquilinos.",
  admin_devices_sub_org: "Aprovisionar dispositivos Moko em {org}.",
  admin_device_new: "Novo dispositivo",
  admin_device_new_title: "Novo dispositivo",
  admin_device_edit_title: "Editar dispositivo",
  admin_device_created: "Dispositivo criado.",
  admin_device_updated: "Dispositivo atualizado.",
  admin_device_deleted: "Dispositivo arquivado.",
  admin_device_delete_title: "Arquivar dispositivo?",
  admin_device_delete_confirm: "O dispositivo {mac} será ocultado.",
  admin_buildings_title: "Edifícios",
  admin_buildings_sub_super: "Agrupar quartos por edifício / ala em todos os inquilinos.",
  admin_buildings_sub_org: "Agrupar quartos por edifício / ala em {org}.",
  admin_building_new: "Novo edifício",
  admin_building_new_title: "Novo edifício",
  admin_building_edit_title: "Editar edifício",
  admin_building_created: "Edifício criado.",
  admin_building_updated: "Edifício atualizado.",
  admin_building_deleted: "Edifício arquivado.",
  admin_building_delete_title: "Arquivar edifício?",
  admin_building_delete_confirm: "«{name}» será ocultado.",
  admin_qa_title: "Ferramentas de teste",
  admin_qa_sub: "Injete eventos / alertas para testar sem hardware Moko real.",
  admin_qa_event_title: "Injetar evento de teste",
  admin_qa_event_sub: "Simula um webhook do Moko.",
  admin_qa_alert_title: "Injetar alerta de teste",
  admin_qa_alert_sub: "Salta a camada de eventos e escreve um alerta diretamente.",
  admin_qa_inject_event: "Injetar evento",
  admin_qa_inject_alert: "Injetar alerta",
  admin_qa_event_done: "Evento injetado.",
  admin_qa_alert_done: "Alerta injetado.",
  admin_qa_disclaimer: "Estes endpoints devem estar desativados em produção.",
  admin_alerts_title: "Política de alertas",
  admin_alerts_sub: "Regras de alerta para toda a {org}. Aplicadas a cada paciente deste inquilino.",
  admin_alerts_quiet_title: "Horas de silêncio",
  admin_alerts_quiet_desc: "Defina quando esta organização está em «modo noturno». Útil para encaminhar alertas não críticos de forma mais discreta.",
  admin_alerts_quiet_hint: "As horas são interpretadas no fuso horário local da organização. O intervalo pode passar da meia-noite (p. ex. 22:00 → 06:00).",
  admin_alerts_night_start: "A noite começa",
  admin_alerts_night_end: "A noite termina",
  admin_alerts_load_failed: "Carregar política de alertas",
  admin_alerts_save_failed: "Guardar política de alertas",
  admin_alerts_saved: "Política de alertas guardada.",
  admin_alerts_clear_title: "Limpar alertas ativos",
  admin_alerts_clear_desc: "Confirme todos os alertas abertos desta organização com um clique.",
  admin_alerts_clear_hint: "Útil após um exercício planeado ou um sensor mal configurado que produziu uma onda de falsos positivos. Os alertas confirmados permanecem no histórico.",
  admin_alerts_ack_all_button: "Confirmar todos",
  admin_alerts_ack_all_title: "Confirmar todos os alertas ativos?",
  admin_alerts_ack_all_confirm: "Isto marcará como confirmado cada alerta aberto em {org}. Esta ação não pode ser anulada.",
  admin_alerts_ack_all_done: "{count} alerta(s) confirmado(s).",
  admin_alerts_ack_all_done_generic: "Todos os alertas ativos confirmados.",
  admin_alerts_ack_all_failed: "Confirmar todos os alertas",
  org_type_nursing_home: "Lar de idosos",
  org_type_assisted_living: "Residência assistida",
  org_type_hospital: "Hospital",
  org_type_home_care: "Cuidados domiciliários",
  role_admin: "Administrador",
  role_caregiver: "Cuidador",
  role_family: "Família",
  status_active: "ativo",
  status_inactive: "inativo",
  confirm: "Confirmar",
  sign_in: "Iniciar sessão",
  sign_up: "Registar",
  email: "E-mail",
  password: "Palavra-passe",
  full_name: "Nome completo",
  create_account: "Criar conta",
  no_account: "Ainda não tem conta?",
  have_account: "Já tem uma conta?",
  login_welcome: "Bem-vindo de volta",
  login_sub: "Inicie sessão para continuar a monitorizar os seus residentes.",
  register_welcome: "Junte-se à E2 Care",
  register_sub: "Crie o seu espaço de trabalho em menos de um minuto.",
  total_residents: "Pacientes",
  active_devices: "Dispositivos ativos",
  open_alerts: "Alertas abertos",
  offline_gateways: "Dispositivos offline",
  falls_7d: "Quedas (7d)",
  sos_7d: "SOS (7d)",
  low_battery: "Bateria fraca",
  critical_residents: "Críticos",
  status_ok: "Tudo bem",
  status_warning: "Atenção",
  status_critical: "Crítico",
  status_online: "Online",
  status_offline: "Offline",
  search: "Pesquisar",
  filter: "Filtrar",
  all: "Todos",
  refresh: "Atualizar",
  loading: "A carregar…",
  no_results: "Ainda nada aqui.",
  view_profile: "Ver perfil",
  showing_n_of_m: "A mostrar {n} de {m}",
  load_more: "Carregar mais",
  auto_refresh: "Ao vivo · atualização automática",
  auto_refresh_paused: "Em pausa (carregar mais ativo)",
  updated_just_now: "Atualizado agora",
  updated_n_sec_ago: "Atualizado há {n}s",
  updated_n_min_ago: "Atualizado há {n}m",
  acknowledge: "Confirmar",
  acknowledged: "Confirmado",
  ack_all: "Confirmar todos",
  ack_all_confirm: "Confirmar os {count} alerta(s) ativo(s)?",
  ack_all_running: "A confirmar…",
  ack_all_done: "{count} alerta(s) confirmado(s).",
  ack_all_partial: "{ok} confirmado(s) · {fail} falhado(s).",
  last_seen: "Visto pela última vez",
  battery: "Bateria",
  signal: "Sinal",
  firmware: "Firmware",
  room: "Apt. / Quarto",
  age: "Idade",
  emergency_contact: "Contacto de emergência",
  notes: "Notas",
  assigned_devices: "Dispositivos atribuídos",
  recent_events: "Eventos recentes",
  timeline_24h: "Últimas 24 horas",
  delivery_status: "Estado de entrega",
  acknowledged_by: "Confirmado por",
  dashboard_title: "Visão geral",
  dashboard_sub: "Uma leitura rápida de tudo o que acontece nos lares que cuida.",
  residents_title: "Pacientes",
  residents_sub: "Pessoas que está a monitorizar agora.",
  devices_title: "Dispositivos",
  devices_sub: "Sensores e pulseiras.",
  devices_sub_admin: "Gateways, sensores e pulseiras.",
  events_title: "Eventos ao vivo",
  events_sub: "Fluxo cronológico de cada dispositivo conectado.",
  alerts_title: "Alertas",
  alerts_sub: "Notificações encaminhadas para família e cuidadores.",
  settings_title: "Definições",
  settings_sub: "As suas preferências e regras de notificação.",
  users_title: "Equipa",
  users_sub: "Cuidadores, família e administradores com acesso.",
  falls_chart_title: "Quedas e SOS — últimos 7 dias",
  recent_alerts_title: "Alertas críticos recentes",
  no_alerts: "Sem alertas abertos. Todos estão em segurança.",
  event_fall: "Queda detetada",
  event_sos: "Botão SOS premido",
  event_door_open: "Porta aberta",
  event_door_close: "Porta fechada",
  event_inactivity: "Inatividade prolongada",
  event_low_battery: "Bateria fraca",
  event_offline: "Dispositivo offline",
  event_online: "Dispositivo novamente online",
  event_heartbeat: "Batimento",
  event_button_press: "Botão premido",
  device_gateway: "Gateway Bluetooth",
  device_door_sensor: "Sensor de porta",
  device_bracelet: "Pulseira",
  device_unknown: "Dispositivo desconhecido",
  language: "Idioma",
  notifications: "Notificações",
  quiet_hours: "Horas silenciosas",
  escalation: "Política de escalonamento",
  just_now: "agora mesmo",
  min_ago: "min",
  h_ago: "h",
  d_ago: "d",
  demo_hint: "Conta demo: admin@e2care.lv / Care2024!",
  open_menu: "Abrir menu",
  close_menu: "Fechar menu",
  care_team: "Equipa de cuidados",
  family_members: "Família",
  no_caregivers: "Sem cuidadores atribuídos.",
  no_family: "Sem familiares ligados.",
  add_caregiver: "Adicionar cuidador",
  add_family: "Adicionar familiar",
  select_user: "Selecione um utilizador…",
  cancel: "Cancelar",
  add: "Adicionar",
  remove: "Remover",
  save: "Guardar",
  relationship: "Parentesco",
  relationship_son: "Filho",
  relationship_daughter: "Filha",
  relationship_spouse: "Cônjuge",
  relationship_other: "Outro",
  notify_via: "Notificar via",
  call_contact: "Ligar",
  view_resident: "Abrir perfil",
  address: "Morada",
  admin_only_section: "Ferramentas de admin",
  rooms_title: "Quartos",
  rooms_sub: "Todos os quartos que supervisiona — pacientes, dispositivos e estado atual.",
  room_name: "Quarto",
  room_type: "Tipo",
  room_type_private_room: "Quarto privado",
  room_type_shared_room: "Quarto partilhado",
  room_type_apartment: "Apartamento",
  room_type_corridor: "Corredor",
  room_type_common_area: "Área comum",
  room_floor: "Piso",
  room_state: "Estado atual",
  door: "Porta",
  window: "Janela",
  door_open_state: "Aberta",
  door_closed_state: "Fechada",
  door_unknown_state: "Desconhecido",
  room_no_devices: "Ainda sem dispositivos neste quarto.",
  room_no_patients: "Ainda sem pacientes atribuídos a este quarto.",
  room_patients: "Pacientes no quarto",
  room_devices: "Dispositivos no quarto",
  room_activity: "Cronologia de atividade",
  rooms_filter_all_types: "Todos os tipos",
  widget_active_alerts: "Alertas ativos",
  widget_active_alerts_sub: "Críticos, não resolvidos e confirmados",
  widget_patients_status: "Estado dos pacientes",
  widget_devices_health: "Saúde dos dispositivos",
  widget_room_activity: "Atividade dos quartos",
  widget_recent_events: "Feed de eventos ao vivo",
  widget_connectivity: "Conectividade",
  metric_critical: "Crítico",
  metric_unresolved: "Não resolvido",
  metric_acknowledged_count: "Confirmados",
  metric_total: "Total",
  metric_active: "Ativos",
  metric_online: "Online",
  metric_offline: "Offline",
  metric_ota_pending: "OTA pendente",
  metric_battery_warn: "Bateria fraca",
  metric_doors_open: "Portas abertas",
  metric_windows_open: "Janelas abertas",
  metric_signal_avg: "Sinal médio",
  metric_last_comm: "Última com.",
  metric_packets: "Pacotes / h",
  view_all: "Ver tudo",
  status_new: "Novo",
  status_acknowledged: "Confirmado",
  status_resolved: "Resolvido",
  status_resolved_local: "Resolvido (local)",
  resolve: "Resolver",
  add_note: "Adicionar nota",
  save_note: "Guardar nota",
  resolve_local_badge: "apenas este dispositivo",
  resolve_local_hint: "Marca o alerta como resolvido apenas no seu navegador. O servidor e os outros membros da equipa continuam a vê-lo como aberto.",
  note_placeholder: "Adicione contexto para a equipa…",
  notes_count: "{n} nota(s)",
  device_detail: "Detalhe do dispositivo",
  device_diagnostics: "Diagnóstico",
  device_firmware_history: "Histórico de firmware",
  device_ota_config: "Configuração OTA",
  device_ota_status: "Estado OTA",
  device_signal: "Qualidade do sinal",
  device_mac: "Endereço MAC",
  device_serial: "Número de série",
  fall_sensitivity: "Sensibilidade a quedas",
  transmission_interval: "Intervalo de transmissão",
  low_battery_threshold: "Limite de bateria fraca",
  ota_idle: "Inativo",
  ota_pending: "Pendente",
  ota_deploying: "A implementar",
  ota_failed: "Falhou",
  events_filter_severity: "Gravidade",
  events_filter_room: "Quarto",
  events_filter_patient: "Paciente",
  events_filter_device: "Dispositivo",
  severity_info: "Info",
  severity_warning: "Aviso",
  severity_critical: "Crítico",
  telegram_title: "Alertas do Telegram",
  telegram_desc: "Receba alertas no Telegram para os residentes que lhe foram atribuídos.",
  telegram_connect: "Ligar Telegram",
  telegram_connected: "Telegram ligado",
  telegram_connected_as: "Ligado ao Telegram como {name}",
  telegram_connect_success: "Telegram ligado com sucesso",
  telegram_connect_error: "Não foi possível ligar o Telegram. Tente novamente.",
  telegram_missing_bot: "Bot do Telegram não configurado. Defina REACT_APP_TELEGRAM_BOT no ficheiro env.",
  telegram_disconnect: "Desligar",
  telegram_disconnect_success: "Telegram desligado.",
  telegram_disconnect_error: "Não foi possível desligar o Telegram. Tente novamente.",
  telegram_already_linked: "Esta conta do Telegram já está associada a outro utilizador e2-care.",
  telegram_switch_q: "Usar outra conta do Telegram?",
  telegram_switch_intro: "O Telegram lembra-se de qual conta está autenticada em todos os sites. Para usar outra:",
  telegram_switch_step1: "Abra o Telegram Web e termine a sessão da sua conta atual.",
  telegram_switch_step2: "Volte aqui e recarregue o botão abaixo, depois inicie sessão com a outra conta.",
  telegram_open_web: "Abrir Telegram Web",
  telegram_reload_widget: "Terminei a sessão — recarregar o botão",
  lang_autodetected_toast: "Idioma detetado: {language}. Pode alterá-lo nas Definições.",
  admin_view_active: "Ativos",
  admin_view_archived: "Arquivados",
  admin_restore: "Restaurar",
  admin_restored: "Restaurado.",
  admin_hard_delete: "Eliminar permanentemente",
  admin_hard_delete_title: "Eliminar permanentemente?",
  admin_hard_delete_confirm: "«{name}» será removido permanentemente da base de dados. Esta ação não pode ser anulada.",
  admin_hard_deleted: "Eliminado permanentemente.",
  admin_no_archived: "Sem elementos arquivados.",
  language_desc: "Usada para a interface da aplicação e para as suas notificações Telegram + push.",
  language_saved: "Idioma atualizado.",
  language_error: "Não foi possível atualizar o idioma. Tente novamente.",
  admin_field_language: "Idioma",
  edit: "Editar",
  generic_error: "Algo correu mal. Tente novamente.",
  caregiver_added: "Cuidador adicionado.",
  caregiver_removed: "Cuidador removido.",
  family_added: "Familiar adicionado.",
  family_removed: "Familiar removido.",
  menu: "Menu",
  dl_companion_app: "Aplicação complementar",
  dl_hero_title: "E2 Care para Android",
  dl_hero_sub: "Instale a aplicação complementar num telefone equipado com Moko para retransmitir alertas, configurar dispositivos e manter-se ligado à sua equipa de cuidados — mesmo quando o painel está fechado.",
  dl_android_apk: "APK Android",
  dl_version_loading: "a carregar versão…",
  dl_released: "Lançado a {date}",
  dl_download_apk: "Transferir APK",
  dl_unavailable: "Indisponível",
  dl_preparing: "A preparar…",
  dl_manifest_error: "Não foi possível carregar o manifesto. Tente atualizar; se o problema persistir, o servidor de compilação pode estar a ser reimplementado.",
  dl_whats_new: "Novidades",
  dl_installing_title: "Instalação no seu telefone",
  dl_step1: "Toque em «Transferir APK» acima. O seu navegador pode avisar que os ficheiros APK podem danificar o dispositivo — esse aviso é normal para qualquer instalador transferido fora da Play Store.",
  dl_step2: "Abra o ficheiro transferido. O Android irá pedir-lhe para permitir instalações a partir deste navegador na primeira vez — ative a permissão e volte.",
  dl_step3: "Toque em «Instalar» e depois em «Abrir» quando terminar.",
  dl_step4: "Inicie sessão com as suas credenciais E2 Care.",
  dl_iphone_note: "A versão para iPhone chegará mais tarde. Por agora, use o painel web.",
  dl_back_to_dashboard: "Voltar ao painel",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Alterar a organização limpa a atribuição atual de quarto e paciente.",
  admin_view_full: "Lista completa",
  device_filter_assignment: "Atribuição",
  device_filter_patient: "Atribuído a paciente",
  device_filter_room: "Atribuído a quarto",
  device_filter_unassigned: "Não atribuído",
  admin_all_orgs: "Todas as organizações",
  pagination_prev: "Anterior",
  pagination_next: "Seguinte",
  pagination_per_page: "Por página",
  pagination_page_of: "Página {page} de {pages}",
  pagination_total: "{total} no total",
};
export default pt;
